import { CompanyPageCompanyFragment } from 'generated/graphql';
import AiInterviewScoreHidingSection from 'views/Company/CompanyView/components/AiInterviewScoreHidingSection/AiInterviewScoreHidingSection';
import { AssessmentsSection } from 'views/Company/CompanyView/components/AssessmentsSection/AssessmentsSection';
import CandidatePortalSection from 'views/Company/CompanyView/components/CandidatePortalSection/CandidatePortalSection';
import IntegrityMonitoringSection from 'views/Company/CompanyView/components/IntegrityMonitoringSection/IntegrityMonitoringSection';
import InterviewGuideSection from 'views/Company/CompanyView/components/InterviewGuideSection/InterviewGuideSection';
import NotificationsSection from 'views/Company/CompanyView/components/NotificationsSection/NotificationsSection';
import OtherSection from 'views/Company/CompanyView/components/OtherSection/OtherSection';
import RoleSkillsProfileSection from 'views/Company/CompanyView/components/RoleSkillsProfileSection/RoleSkillsProfileSection';
import InterviewEvaluationSection from '../InterviewEvaluationSection/InterviewEvaluationSection';
import SpottedZebraScoreSection from '../SpottedZebraScoreSection/SpottedZebraScoreSection';
import styles from './FeaturesTab.module.scss';
import ShortlistingSection from '../ShortlistingSection/ShortlistingSection';

type FeaturesTabProps = {
  company: CompanyPageCompanyFragment;
};

export function FeaturesTab({ company }: FeaturesTabProps) {
  return (
    <div className={styles.container}>
      <RoleSkillsProfileSection company={company} />
      <ShortlistingSection company={company} />
      <InterviewGuideSection company={company} />
      <InterviewEvaluationSection company={company} />
      <AssessmentsSection company={company} />
      <NotificationsSection company={company} />
      <IntegrityMonitoringSection company={company} />
      <SpottedZebraScoreSection company={company} />
      <AiInterviewScoreHidingSection company={company} />
      <OtherSection company={company} />
      <CandidatePortalSection company={company} />
    </div>
  );
}
